import React, { useEffect, useState } from 'react';

const SplashScreen = ({ onComplete, minimumDuration = 2000 }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => {
        onComplete?.();
      }, 500); // Wait for fade animation
    }, minimumDuration);

    return () => clearTimeout(timer);
  }, [minimumDuration, onComplete]);

  return (
    <div 
      className={`fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-purple-600 via-purple-700 to-indigo-800 transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div 
          className="absolute -top-20 -right-20 w-64 h-64 bg-purple-400 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"
          style={{ animationDuration: '3s' }}
        />
        <div 
          className="absolute -bottom-20 -left-20 w-64 h-64 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"
          style={{ animationDuration: '3s', animationDelay: '1s' }}
        />
        <div 
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-indigo-400 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse"
          style={{ animationDuration: '3s', animationDelay: '2s' }}
        />
      </div>

      {/* Content */}
      <div className="relative flex flex-col items-center">
        {/* Logo */}
        <div className="relative mb-6 animate-[scaleIn_0.6s_ease-out]">
          <div className="relative w-24 h-24">
            {/* Back square */}
            <div 
              className="absolute bg-white/30 rounded-lg"
              style={{ 
                width: '52%', 
                height: '52%', 
                top: '8%', 
                left: '8%',
              }}
            />
            {/* Middle square */}
            <div 
              className="absolute bg-white/50 rounded-lg"
              style={{ 
                width: '52%', 
                height: '52%', 
                top: '24%', 
                left: '24%',
              }}
            />
            {/* Front square */}
            <div 
              className="absolute bg-white rounded-lg shadow-lg"
              style={{ 
                width: '52%', 
                height: '52%', 
                top: '40%', 
                left: '40%',
              }}
            />
          </div>
        </div>

        {/* App name */}
        <h1 
          className="text-4xl font-bold text-white tracking-tight mb-2 animate-[fadeInUp_0.6s_ease-out_0.2s_both]"
        >
          Boply
        </h1>

        {/* Tagline */}
        <p 
          className="text-purple-200 text-sm tracking-wide animate-[fadeInUp_0.6s_ease-out_0.4s_both]"
        >
          Band & Gig Management
        </p>

        {/* Loading indicator */}
        <div className="mt-10 animate-[fadeIn_0.6s_ease-out_0.6s_both]">
          <div className="flex gap-1.5">
            <div 
              className="w-2 h-2 bg-white/60 rounded-full animate-bounce"
              style={{ animationDelay: '0ms' }}
            />
            <div 
              className="w-2 h-2 bg-white/60 rounded-full animate-bounce"
              style={{ animationDelay: '150ms' }}
            />
            <div 
              className="w-2 h-2 bg-white/60 rounded-full animate-bounce"
              style={{ animationDelay: '300ms' }}
            />
          </div>
        </div>
      </div>

      {/* Keyframe animations */}
      <style>{`
        @keyframes scaleIn {
          0% {
            opacity: 0;
            transform: scale(0.5);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
        
        @keyframes fadeInUp {
          0% {
            opacity: 0;
            transform: translateY(20px);
          }
          100% {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default SplashScreen;